module.exports = __webpack_public_path__ + "img/product-forbidden-2.eb06f083.png";